import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APICongTo = {
  LIST_CONG_TO: `${BASE_API_URL_CAP_DIEN}/cong-to/list`,
  SYNC_CONG_TO: `${BASE_API_URL_CAP_DIEN}/cong-to/sync`,
};
